import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import type { PreviewCalendarData } from "./preview-calendar";

/** Live Bókun read: only for an opened tour calendar. Cards use getTourCards. */
export const getPreviewCalendar = createServerFn({ method: "GET" })
  .inputValidator(z.object({ id: z.string().regex(/^\d{1,12}$/), currency: z.enum(["MXN", "USD", "EUR", "GBP", "CAD"]).default("MXN"), lang: z.enum(["es", "en", "fr", "it", "de", "pt"]).default("es") }))
  .handler(async ({ data }): Promise<PreviewCalendarData> => {
    const { assertPublicBokunId } = await import("./public-catalog-guard.server");
    await assertPublicBokunId(data.id);
    const { buildPreviewCalendar } = await import("./preview-calendar-build.server");
    return buildPreviewCalendar(data.id, data.lang, data.currency);
  });
